import {Trans} from "react-i18next";

const TransactionDirection = ({ transaction }) => {
  return transaction?.type === 'deposit' ?
    <Trans>Received</Trans> :
    <Trans>Sent</Trans>;
};
export default TransactionDirection;